export { default as getLocalizedField } from './getLocalizedField';
